const selectors = {
  button: '[data-scroll-down]',
};

class ScrollButton {
  constructor(el) {
    this.wrapper = el;
    this.init();
  }
  init() {
    const buttons = this.wrapper.querySelectorAll(selectors.button);
    if (buttons) {
      buttons.forEach(btn => {
        btn.addEventListener('click', this.scroll.bind(this));
      });
    }
  }
  scroll() {
    const bottom = this.wrapper.offsetTop + this.wrapper.clientHeight;
    window.scroll({
      top: bottom,
      left: 0,
      behavior: 'smooth',
    });
  }
}

const scrollButton = {
  onLoad() {
    this.headerSection = new ScrollButton(this.container);
  },
  onUnload: function() {
    this.headerSection.delete();
  },
};

export default scrollButton;
